import BaseEndpoint from '@spa/apps/trustup-pro-base-js/endpoints/BaseEndpoint';
import WorksiteCollection from '../collections/WorksiteCollection';
import Worksite from '../models/Worksite';

export default class WorksitePlanningEndpoint extends BaseEndpoint
{

    constructor()
    {
        super(
            'worksite',
            {
                'path': 'worksites/planning',
                'responseKey': 'worksite',
                'responseKeyPlural': 'worksites',
                'modelClass': Worksite,
                'collectionClass': WorksiteCollection
            }
        );
    }

}